<template>
	<v-container fluid id="loginCss" fill-height>
		
		<ul class="circles">
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	  </ul>

	  <v-row justify="center">
	  	<v-col cols="10" sm="6" md="4" lg="3">
				<v-card class="transparent elevation-0">

					<v-card-title primary-title class="text-center mb-4">
						<v-spacer></v-spacer>
					  <v-img src="@/assets/fondos/logo_blanco.png" contain max-width="150"      v-if="escuela && escuela == 1"></v-img>
					  <v-img src="@/assets/fondos/logo_blanco_fast.png" contain max-width="200" v-if="escuela && escuela == 2"></v-img>
						<v-spacer></v-spacer>
					</v-card-title>

				  <v-form
				    ref="form"
				    v-model="valid"
				    lazy-validation
				  >
				    <v-text-field
				      v-model="usuario"
				      :rules="[rules.required]"
				      label="Usuario"
				      required
				      rounded
				      filled
				      color="primary"
				      class="white mb-4"
				      hide-details
				    ></v-text-field>

				    <v-text-field
	            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
	            :rules="[rules.required]"
	            :type="showPassword ? 'text' : 'password'"
	            name="input-10-2"
	            label="Contraseña"
	            v-model="password"
	            @click:append="showPassword = !showPassword"
	            rounded
	            filled
	            color="primary"
	            class="white mb-4"
	            hide-details
	            @keyup.enter="validarUsuario()"
	          ></v-text-field>
				  </v-form>

				  <v-card-actions>
				  	<div class="text-caption white--text" @click="dialogAvisoPrivacidad = true">Aviso de privacidad</div>
				    <v-spacer></v-spacer>
				    <v-btn
				      color="white"
				      class="primary--text text-capitalize px-6"
				      @click="validarUsuario()"
				      rounded
				    >
				      Iniciar sesión
				    </v-btn>
				  </v-card-actions>
				</v-card>
	  	</v-col>
	  </v-row>

	  <!-- boton para soporte -->
	  <v-speed-dial
      bottom
      right
      absolute
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          fab
          @click="soporteLogin = true"
        >
		<img width="35" height="35" src="../../assets/iconos/asistente.png" alt="technical-support" class="mb-1"/>
          <!-- <v-icon color="primary">
            mdi-headphones-settings
          </v-icon> -->
        </v-btn>
      </template>
    </v-speed-dial>

    <!-- Boton para el exci -->
    <v-speed-dial
      bottom
      left
      absolute
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          :to="{name: 'RegistroExci'}"
          class="text-capitalize"
          rounded
        >
          Curso EXCI
        </v-btn>
      </template>
    </v-speed-dial>


    <div class="text-center">
	    <v-bottom-sheet v-model="soporteLogin" max-width="600" rounded>
	      <v-list>
	        <v-subheader>Soporte <v-spacer></v-spacer> <v-btn icon @click="soporteLogin = false"><v-icon>mdi-close</v-icon></v-btn></v-subheader>
	        <v-list-item
	          v-for="tile in settings"
	          :key="tile.title"
	          :to="{name: tile.path}"
	        >
	          <v-list-item-avatar>
	            <v-avatar
	              size="32px"
	              tile
	            >
	              <v-icon :color="tile.color"> {{ tile.icon }} </v-icon>
	            </v-avatar>
	          </v-list-item-avatar>
	          <v-list-item-title>{{ tile.title }}</v-list-item-title>
	        </v-list-item>
	      </v-list>
	    </v-bottom-sheet>
	  </div>

	  <v-dialog
      v-model="dialogAvisoPrivacidad"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Aviso de Privacidad
        </v-card-title>

        <v-card-text>
          Este Aviso de Privacidad describe cómo FAST ENGLISH (en adelante "nosotros", "nuestro" o "la Empresa") recopila, utiliza y protege la información personal que recabamos a través de nuestra aplicación móvil.

          <br/>
          <br/>
					<strong>Información que Recopilamos:</strong>
          <br/>
          <br/>

          <ul>
          	<li>
							<strong>Nombre:</strong> Recopilamos su nombre para personalizar la experiencia en nuestra aplicación.
          	</li>
          	<li>
							<strong>Correo Electrónico:</strong> Recopilamos su dirección de correo electrónico para que pueda acceder y utilizar nuestra aplicación. Su correo electrónico también puede ser utilizado para enviarle comunicaciones relacionadas con la aplicación y su uso.
          	</li>
          	<li>
							<strong>Teléfono:</strong> Recopilamos su número de teléfono para fines de contacto en caso de que sea necesario para confirmar pagos o resolver problemas relacionados con su cuenta.
          	</li>
          </ul>
          <br/>
          <br/>
					
					<b>Uso de la Información:</b>
          <br/>
          <br/>

					Utilizamos la información que recopilamos para los siguientes fines:
          <br/>
          <br/>
          <ul>
          	<li>
							Facilitar su acceso y uso de la aplicación.
          	</li>
          	<li>
							Brindar soporte técnico y atención al cliente.
          	</li>
          	<li>
							Enviar comunicaciones relacionadas con la aplicación y los pagos.
          	</li>
          	<li>
							Mejorar nuestros servicios y personalizar su experiencia.
          	</li>
          </ul>
          
          <br/>
          <br/>
				
					<b>Seguridad de la Información:</b>
          <br/>
          <br/>

					Tomamos medidas de seguridad razonables para proteger la información personal que recopilamos. Sin embargo, no podemos garantizar la seguridad completa de la información transmitida a través de Internet o almacenada en nuestra aplicación.
          <br/>
          <br/>

					<b>Compartir Información:</b>
          <br/>
          <br/>

					No vendemos ni compartimos su información personal con terceros, excepto cuando sea necesario para los fines descritos anteriormente o cuando estemos legalmente obligados a hacerlo.
          <br/>
          <br/>

					<b>Derechos del Usuario:</b>
          <br/>
          <br/>

					Usted tiene derechos respecto a su información personal, incluido el acceso, corrección y eliminación de sus datos. Puede ejercer estos derechos comunicándose con nosotros a través de la información de contacto proporcionada al final de este aviso.

          <br/>
          <br/>
					<b>Cambios en este Aviso:</b>

          <br/>
          <br/>
					Nos reservamos el derecho de actualizar este Aviso de Privacidad en cualquier momento. Se le notificarán los cambios a través de la aplicación o por otros medios según corresponda.

          <br/>
          <br/>
					<b>Contacto:</b>

          <br/>
          <br/>
					Si tiene preguntas o inquietudes sobre este Aviso de Privacidad, puede contactarnos a través de:
          <br/>
          <br/>

					FAST ENGLISH
          <br/>
					Av. LindaVista 209, Col. Linda Vista, Guadalupe N.L.
          <br/>
					8121642470
          <br/>
					informes@fastenglish.com.mx
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAvisoPrivacidad = false"
          >
            Acepto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

	  <Alerta      v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader      v-if="cargar"    :loader="loader"/>

	</v-container>
</template>

<script>
	import {
    ActionPerformed,
    PushNotificationSchema,
    PushNotifications,
    Token,
  } from '@capacitor/push-notifications';
  import { Device } from '@capacitor/device';


	import { mapActions } from 'vuex'
	// Dependencias
  const md5     = require('md5')

  // Componentes
  import Alerta        from '@/components/alertas/Alerta.vue'
  import Loader        from '@/components/alertas/Loader.vue'


  // Mixins
  import  validarErrores from '@/mixins/validarErrores.js';

  export default {
  	components:{
  		Alerta,
  		Loader
  	},

  	mixins:[validarErrores],

    data: () => ({
    	dialogAvisoPrivacidad:false,
    	escuela: null,
    	settings: [
        { icon: 'mdi-lock' , title: 'Recuperar contraseña' , path: 'RecuperarPassword', color: 'black'},
        { icon: 'mdi-email', title: 'No me llego el correo', path: 'ReenviarCorreo'   , color: 'primary'}
      ],

    	soporteLogin: false,
      valid: true,
    	
    	// Datos del usuario
    	usuario:'',
    	password:'',
      showPassword: false,
      rules: {
        required: value => !!value || 'Requerido.'
      },

      respuestaAlerta: false,
      loader: true,
      cargar: false,
      parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

     	idusuario: 0
    }),

    created ( ){
    	this.escuela = this.$store.state.ESCUELA 
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario' ]),

      validarDatos () {
        return this.$refs.form.validate()
      },

      validarUsuario (){
      	if( this.validarDatos() ){
      		this.cargar = true
      		// validar los datos del usuario
      		const payload = {
	      		usuario: this.usuario.trim(),
	      		password: md5(this.password.trim())
	      	}

	      	this.$http.post('usuario.validar.acceso', payload).then( async (response) => {
	      		this.idusuario = response.body.usuario.id 
	      		this.grabarMovil( this.idusuario )
	      		this.activarNotificaciones( this.idusuario )
	      		this.grabarUsuario( response.body )
	      		this.cargar = false
	      	}).catch( error => {
	      		this.cargar = false
	      		if( error.status == 400 || error.status == 500){
	      			this.parametros.mensaje      = error.body.message
	      			this.parametros.dialogError  = true 
	      			this.parametros.color        = '#FF2C2C' 
	      			this.respuestaAlerta         = true 
	      		}
	      	}).finally(()=>{ this.cargar = false })
      	}
      },

      async activarNotificaciones ( id ) {
      	console.log('Initializing HomePage');
        // Request permission to use push notifications
        // iOS will prompt user and return if they granted permission or not
        // Android will just grant without prompting
        PushNotifications.requestPermissions().then(result => {
          if (result.receive === 'granted') {
            // Register with Apple / Google to receive push via APNS/FCM
            PushNotifications.register();
          } else {
            // Show some error
          }
        });

        // Registrar el dispositivo y regresar el token
        PushNotifications.addListener('registration', token => {
        	this.grabarTokenNotificacion( this.idusuario, token.value )
          console.info('Push registration success, token: ' + token.value);
        });

        // Some issue with our setup and push will not work
        PushNotifications.addListener('registrationError', error => {
          console.info('Error on registration: ' + JSON.stringify(error));
        });

        // Show us the notification payload if the app is open on our device
        PushNotifications.addListener('pushNotificationReceived', notification => {
          // Carga util si esta abierto el dispositivo
          // alert('Push received: ' + JSON.stringify(notification));
        });

        // Show us the notification payload if the app is open on our device
        PushNotifications.addListener('alertaDescuento', notification => {
          // Carga util si esta abierto el dispositivo
          // alert('Push received: ' + JSON.stringify(notification));
        });


        // Show us the notification payload if the app is open on our device
        PushNotifications.addListener('alertaRetardoSucursal', notification => {
          // Carga util si esta abierto el dispositivo
          // alert('Push received: ' + JSON.stringify(notification));
        });

        // Show us the notification payload if the app is open on our device
        PushNotifications.addListener('calificarClase', notification => {
          // Carga util si esta abierto el dispositivo
          // alert('Push received: ' + JSON.stringify(notification));
        });

        // Metodo que se manda a llamar cuando se toca la notificacion
        PushNotifications.addListener('pushNotificationActionPerformed', notification => {
          // alert('Push action performed: ' + JSON.stringify(notification));
        });
      },

      grabarTokenNotificacion( id, token ){
      	const payload = { id: this.idusuario, token }
      	this.$http.post('usuario.token.notificacion', payload).then( response => {
      		this.cargar = false
      	}).catch( error => {
      		this.cargar = false
      		if( error.status == 400 || error.status == 500){
      			this.parametros.mensaje      = error.body.message
      			this.parametros.dialogError  = true 
      			this.parametros.color        = '#FF2C2C' 
      			this.respuestaAlerta         = true 
      		}
      	}).finally(()=>{ this.cargar = false })
      },

      async grabarMovil( idusuario ){
      	// Actualizar el tipo de dispositivo, esto es para poder recibir notificaciones
      	const info = await Device.getInfo();
      	const payload = { id: idusuario, dispositivo: info.operatingSystem }
      	this.$http.post('usuario.tipodispositivo', payload).then( response => {
	        this.cargar = false
	      }).catch( error => {
	        this.cargar = false
	        if( error.status == 400 || error.status == 500){
	          this.parametros.mensaje      = error.body.message
	          this.parametros.dialogError  = true 
	          this.parametros.color        = '#FF2C2C' 
	          this.respuestaAlerta         = true 
	        }
	      }).finally(()=>{ this.cargar = false })

      },

      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>

